module.exports = __webpack_public_path__ + "img/horizontal_5_1_7005.031c2a53.png";